(function() { module.exports = window["Sentry"]; }());